import { getSectionHTML, trapFocus } from '@theme/utilities';

class QuickShop extends HTMLElement {

  #touchStartY = 0;
  #focusTrap = null;
  #triggerElement = null;

  connectedCallback() {
    this.addEventListener('click', this.#onClick);
    document.addEventListener('theme:escape', () => this.close());
    document.addEventListener('cart:added', () => this.close());
    this.addEventListener('touchstart', this.#onTouchStart, { passive: true });
    this.addEventListener('touchend', this.#onTouchEnd, { passive: true });
  }

  #onClick = (e) => {
    if (e.target.closest('[data-close-quick-shop]') || e.target.closest('[data-overlay]')) {
      this.close();
    }
  };

  #onTouchStart = (e) => {
    this.#touchStartY = e.touches[0].clientY;
  };

  #onTouchEnd = (e) => {
    const deltaY = e.changedTouches[0].clientY - this.#touchStartY;
    if (deltaY > 80) this.close();
  };

  open(triggerElement) {
    this.#triggerElement = triggerElement || document.activeElement;
    this.setAttribute('open', '');
    this.setAttribute('aria-expanded', 'true');
    this.#focusTrap = trapFocus(this);
    requestAnimationFrame(() => {
      const closeBtn = this.querySelector('[data-close-quick-shop]');
      const firstFocusable = this.querySelector('button, [href], input, select, [tabindex]:not([tabindex="-1"])');
      (closeBtn || firstFocusable)?.focus();
    });
  }

  close() {
    this.removeAttribute('open');
    this.setAttribute('aria-expanded', 'false');
    if (this.#focusTrap) {
      this.#focusTrap.release();
      this.#focusTrap = null;
    }
    if (this.#triggerElement) {
      this.#triggerElement.focus();
      this.#triggerElement = null;
    }
  }
}

class QuickShopButton extends HTMLElement {

  #loading = false;

  connectedCallback() {
    this.addEventListener('click', this.#handleClick);
    this.addEventListener('keydown', this.#handleKeydown);
  }

  disconnectedCallback() {
    this.removeEventListener('click', this.#handleClick);
    this.removeEventListener('keydown', this.#handleKeydown);
  }

  #handleKeydown = (e) => {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      this.#handleClick(e);
    }
  };

  #handleClick = async (event) => {
    const handle = this.dataset.openQuickShop;
    if (!handle || this.#loading) return;

    this.#loading = true;
    this.setAttribute('aria-disabled', 'true');

    const quickShop = document.querySelector('quick-shop');
    if (!quickShop) {
      this.#loading = false;
      this.removeAttribute('aria-disabled');
      return;
    }

    const url = new URL(`${Theme.routes.root_url}products/${handle}`, window.location.origin);
    const html = await getSectionHTML('quick-shop', url);

    const entry = quickShop.querySelector('[data-quick-shop-entry]');
    entry.innerHTML = html;

    yotpoWidgetsContainer.initWidgets();

    quickShop.open(this);

    this.#loading = false;
    this.removeAttribute('aria-disabled');
  };
}

if (!customElements.get('quick-shop')) {
  customElements.define('quick-shop', QuickShop);
}

if (!customElements.get('quick-shop-button')) {
  customElements.define('quick-shop-button', QuickShopButton);
}
